import type { PopoverPassThroughOptions } from "primevue/popover";

export const popover: PopoverPassThroughOptions = {
  root: {}
};
